import style from "./index.module.scss";
import WrapperContent from "../../components/shared/WrapperContent";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HeaderContentNew from "../../components/shared/HeaderContentNew/HeaderContentNew";
import { Analytics } from "../../services";
import moment from 'moment';
import BasicAnalytics from "../../components/analytics/BasicAnalytics";
import AnalyticsByTransportType from "../../components/analytics/AnalyticsByTransportType";
import AnalyticsByCompareOrderPrice from "../../components/analytics/AnalyticsByCompareOrderPrice";

const AnalyticsPage = () => {
  const { t } = useTranslation();
  const [baseMetric, setBaseMetric] = useState();
  const [baseMetricDateStart, setBaseMetricDateStart] = useState(moment().startOf('month').toDate());
  const [baseMetricDateEnd, setBaseMetricDateEnd] = useState(new Date());

  const [monthlyOrderIndicators, setMonthlyOrderIndicators] = useState();
  const [startDateChartTypeTransport, setStartDateChartTypeTransport] = useState(moment().startOf('year').toDate());
  const [endDateChartTypeTransport, setEndDateChartTypeTransport] = useState(new Date());

  const [chartСompareOrderPrice, setChartСompareOrderPrice] = useState();
  const [startDateChartСompareOrderPrice, setStartDateChartСompareOrderPrice] = useState(moment().startOf('year').toDate());

  useEffect(() => {
    fetchBaseMetric();
  }, [baseMetricDateStart, baseMetricDateEnd]);

  useEffect(() => {
    fetchMonthlyOrderIndicators();
  }, [startDateChartTypeTransport, endDateChartTypeTransport]);

  useEffect(() => {
    fetchСompareOrderPrice();
  }, [startDateChartСompareOrderPrice]);

  const fetchBaseMetric = async () => {
    try {
      const startDate = moment(baseMetricDateStart).format("YYYY-MM-DD");
      const endDate = moment(baseMetricDateEnd).format("YYYY-MM-DD");
      const response = await Analytics.getAverageOrderIndicators(startDate, endDate);
      setBaseMetric(response.data);
      // console.log('[baseMetric]', response.data);
    } catch (error) {
      console.error('Error while getting metrics:', error);
    }
  };

  const fetchMonthlyOrderIndicators = async () => {
    try {
      const startDate = moment(startDateChartTypeTransport).format("YYYY-MM-DD");
      const endDate = moment(endDateChartTypeTransport).format("YYYY-MM-DD");
      const response = await Analytics.getMonthlyOrderIndicators(startDate, endDate);
      setMonthlyOrderIndicators(response.data);
      // console.log('[MonthlyMetric]', response.data);
    } catch (error) {
      console.error('Error while getting indicators:', error);
    }
  };

  const fetchСompareOrderPrice = async () => {
    try {
      const startDate = moment(startDateChartСompareOrderPrice).format("YYYY-MM-DD");;
      const response = await Analytics.compareOrderPriceIndicators(startDate);
      setChartСompareOrderPrice(response.data);
      console.log('[СompareOrderPrice]', response.data);
    } catch (error) {
      console.error('Error while getting compare:', error);
    }
  };

  return (
    <>
      <HeaderContentNew title={t('analytics.pageTitle')} displayTitle={true} displayCreateBtn={false} displayReloadBtn={false} />
      <WrapperContent>
        <div className={style.wrapperAnalytics}>
          <BasicAnalytics
            startDate={baseMetricDateStart}
            setStartDate={setBaseMetricDateStart}
            item={baseMetric}
            endtDate={baseMetricDateEnd}
            setEndtDate={setBaseMetricDateEnd}
          />

          {chartСompareOrderPrice && (
            <AnalyticsByCompareOrderPrice
              item={chartСompareOrderPrice}
              startDate={startDateChartСompareOrderPrice}
              setStartDate={setStartDateChartСompareOrderPrice}
            />
          )}

          {monthlyOrderIndicators && (
            <AnalyticsByTransportType
              item={monthlyOrderIndicators}
              startDate={startDateChartTypeTransport}
              setStartDate={setStartDateChartTypeTransport}
              endtDate={endDateChartTypeTransport}
              setEndtDate={setEndDateChartTypeTransport}
            />
          )}

        </div>
      </WrapperContent>
    </>
  );
};

export default AnalyticsPage;
